export default {
  UNIVERS: "PageUnivers",
  DESCENTE: "PageDescente",
  PROMO: "PagePromo",
  THEME: "PageTheme",
  CKDO: "PageCKDO"
}
